import React, {Component} from 'react';
import { unmountComponentAtNode, render} from 'react-dom'

// This is a 'portal' which allows us to place components on the root of the
// body node.
// To use it, wrap a component in a <MountComponentOnBody> with a componentId:
// <MountComponentOnBody componentId="foo"><ModalPopup /></MountComponentOnBody>

const Provider = (props) => {
  const {ProvidedProvider, store} = props;
    return <ProvidedProvider store={store} >
        {props.children}
    </ProvidedProvider>
};

class MountComponentOnBody extends Component {

  constructor(props) {
    super(props);
    this.store = props.store;
    this.provider = props.ProvidedProvider;
  }

  render = () => null;

  portalElement = null;

  componentDidMount() {
    let p = this.props.componentId && document.getElementById(this.props.componentId);
    if (!p) {
      p = document.createElement('div');
      p.id = this.props.componentId;
      document.body.appendChild(p);
    }
    this.portalElement = p;
    this.componentDidUpdate();
  };

  componentWillUnmount() {
    unmountComponentAtNode(this.portalElement);
  };

  componentDidUpdate() {
    render(
      <Provider ProvidedProvider={this.provider} store={this.store} {...this.props}>
        {this.props.children}
      </Provider>, this.portalElement
    );
  }
};

export default MountComponentOnBody;



// WEBPACK FOOTER //
// ./assets/es6/common/components/mount-component-on-body.es6